import { ObjectSchema, date, object, string } from 'yup';
import { useMemo } from 'react';
import { SetupCampaignFormState } from '@Forms/campaign/SetupCampaignFormContext';

export const useSetupCampaignUseCaseSchema = (): ObjectSchema<Partial<SetupCampaignFormState>> => {
  return useMemo(
    () =>
      object<SetupCampaignFormState>().shape({
        description: string().required('description is required'),
        startDate: date().required('start date is required'),
        endDate: date().required('end date is required'),
        status: string().required('status is required'),
      }),
    []
  );
};
